import http from "./httpClient.js";

const CURRENT_SCHOOL_ID_KEY = 'currentSchoolId';

/**
 * Fetch available schools from GET /school (no cache).
 * Backend returns either { data: { school: {...} } } or { data: { schools: [...] } }.
 */
export async function getSchoolList(token) {
    const response = await http.get(`/school`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export function getCurrentSchoolIdFromStorage() {
    return localStorage.getItem(CURRENT_SCHOOL_ID_KEY);
}

export function setCurrentSchoolIdInStorage(schoolId) {
    if (schoolId) {
        localStorage.setItem(CURRENT_SCHOOL_ID_KEY, schoolId);
    } else {
        localStorage.removeItem(CURRENT_SCHOOL_ID_KEY);
    }
}

/**
 * @param {string} token - Auth token
 * @param {{ schoolId?: string, forceLoad?: boolean }} [options] - optional schoolId and forceLoad
 */
export async function getInfoSchool(token, options = {}) {
    const { schoolId: optionSchoolId, forceLoad = false } = typeof options === 'boolean' ? { forceLoad: options } : options;
    const effectiveSchoolId = optionSchoolId || getCurrentSchoolIdFromStorage();
    const schoolDataInLS = localStorage.getItem('school');
    if (schoolDataInLS && !forceLoad && (!effectiveSchoolId || JSON.parse(schoolDataInLS)._id === effectiveSchoolId)) {
        return {
            data: {
                school: {
                    ...JSON.parse(schoolDataInLS),
                }
            }
        };
    }
    const url = effectiveSchoolId ? `/school/${effectiveSchoolId}` : `/school`;
    const response = await http.get(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function createUserBySchoo(dataUser, schoolId, token) {
    const response = await http.post(`/school/${schoolId}/user`, dataUser, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}
export async function updateUserBySchoo(dataUser, schoolId, token) {
    const response = await http.patch(`/school/${schoolId}/user`, dataUser, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}
export async function getAllStudentsBySchoolId(schoolId, token) {
    const response = await http.get(`/school/${schoolId}/students`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function addTeacher(schoolId, dataTeacher, token) {
    const response = await http.post(`/school/${schoolId}/teachers`, {
        teacher: dataTeacher
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function removeTeacher(schoolId, dataTeacher, token) {
    const response = await http.delete(`/school/${schoolId}/teachers/${dataTeacher}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function addAssistant(schoolId, dataAssistant, token) {
    const response = await http.post(`/school/${schoolId}/assistants`, {
        assistant: dataAssistant
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function removeAssistant(schoolId, dataAssistant, token) {
    const response = await http.delete(`/school/${schoolId}/assistants/${dataAssistant}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function getAttendanceTeachers(schoolId, token) {
    const response = await http.get(`/school/${schoolId}/attendance-teachers`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function updateSchool(dataSchool, schoolId, token) {
    const formData = new FormData();

    if (dataSchool.name     !== undefined) formData.append('name',        dataSchool.name     || '');
    if (dataSchool.address  !== undefined) formData.append('address',     dataSchool.address  || '');
    if (dataSchool.city     !== undefined) formData.append('city',        dataSchool.city     || '');
    if (dataSchool.revolutLink !== undefined) formData.append('revolutLink', dataSchool.revolutLink || '');
    if (dataSchool.wiseLink !== undefined) formData.append('wiseLink', dataSchool.wiseLink || '');

    // Logo: Vuetify v-file-input may give a File[] array or a single File
    if (dataSchool.newLogo) {
        const file = Array.isArray(dataSchool.newLogo) ? dataSchool.newLogo[0] : dataSchool.newLogo;
        if (file) formData.append('newLogo', file);
    }

    // Location coordinates from LocationPicker
    if (dataSchool.lat != null && dataSchool.lng != null) {
        formData.append('lat',              String(dataSchool.lat));
        formData.append('lng',              String(dataSchool.lng));
        formData.append('formattedAddress', dataSchool.formattedAddress || '');
    }

    // Let axios set Content-Type automatically so the multipart boundary is correct
    const response = await http.patch(`/school/${schoolId}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export async function toggleTrialEnabled(schoolId, trialEnabled, token) {
    const response = await http.patch(`/school/${schoolId}/toggle-trial`, { trialEnabled }, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}

export function updateSchoolFromLocalStorage(dataSchool) {
    localStorage.setItem('school', JSON.stringify(dataSchool));
}

export { CURRENT_SCHOOL_ID_KEY };
